export default "__VITE_ASSET__1db49b69__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2955375__"